/* eslint-disable import/namespace */
import React, { ReactElement } from 'react';
import * as IconPickerIcons from '../../../../../assets/images/icons';
import { ReactComponent as DefaultEndpointKitItem } from '../images/EndpointKit.svg';

export type DetermineIconToRender = {
  display?: DiagramDisplay;
  uid: string;
};

export const determineIconToRender = ({
  display,
  uid,
}: DetermineIconToRender): ReactElement => {
  if (display?.icon === undefined)
    return <DefaultEndpointKitItem data-component={uid} />;

  const IconComponent =
    IconPickerIcons[display?.icon as keyof typeof IconPickerIcons];

  return <IconComponent data-component={uid} />;
};
